import { t as e, x as t } from "./form-validation-DWYCe0I8.js";
import { contactValidation as n } from "@benchmark/core/utils";
import { CUSTOM_TASK_TYPE as r } from "@benchmark/core/constants";
// src/validators/patient.validator.ts
var i = (t) => {
	if (!t || t.length === 0) return "At least one phone number is required";
	for (let n = 0; n < t.length; n++) {
		let r = t[n], i = n + 1, a = r.rank ? `rank ${r.rank}` : `#${i}`;
		if (!r.value) return `Phone number ${a} cannot be empty`;
		let o = e.phone(!0)(r.value);
		if (o) return `Phone number ${a}: ${o}`;
		if (!r.rank || r.rank < 1) return `Phone number ${a}: Rank must be a positive integer`;
	}
	let r = t.map((e) => e.rank), i = new Set(r);
	if (r.length !== i.size) return "Each phone number must have a unique rank";
	let a = t.map((e) => n.normalizePhone(e.value));
	return new Set(a).size === a.length ? null : "Each phone number must be unique";
}, a = (t) => {
	if (!t || t.length === 0) return null;
	for (let n = 0; n < t.length; n++) {
		let r = t[n], i = n + 1;
		if (!r["first-name"] || r["first-name"].trim() === "") return `Contact ${i} requires a first name`;
		if (!r["last-name"] || r["last-name"].trim() === "") return `Contact ${i} requires a last name`;
		if (!r.phone) return `Contact ${i} requires a phone number`;
		let a = e.phone(!0)(r.phone);
		if (a) return `Contact ${i}: ${a}`;
		if (!r.relationship) return `Contact ${i} requires a relationship`;
	}
	return null;
}, o = (t, n) => {
	let r = {}, i = t[`${n}-relationship-to-subscriber`], a = `${n}-subscriber-phone`;
	if (i && i !== "self") {
		let i = `${n}-subscriber-first-name`, o = `${n}-subscriber-last-name`, s = `${n}-subscriber-dob`, c = e.required(n === "primary" ? "Subscriber First Name" : "Secondary Subscriber First Name")(t[i]);
		c && (r[i] = c);
		let l = e.required(n === "primary" ? "Subscriber Last Name" : "Secondary Subscriber Last Name")(t[o]);
		l && (r[o] = l);
		let u = e.combine(e.required(n === "primary" ? "Subscriber Date of Birth" : "Secondary Subscriber Date of Birth"), (t) => e.date(!0, n === "primary" ? "Subscriber Date of Birth" : "Secondary Subscriber Date of Birth")(t))(t[s]);
		if (u && (r[s] = u), t[a]) {
			let n = e.phone(!1)(t[a]);
			n && (r[a] = n);
		}
	} else if (t[a]) {
		let n = e.phone(!1)(t[a]);
		n && (r[a] = n);
	}
	return r;
}, s = (t) => {
	let n = {};
	if (!t["self-pay"]) {
		let r = e.required("Insurance Provider")(t["primary-insurance-provider"]);
		r && (n["primary-insurance-provider"] = r);
		let i = e.required("Subscriber ID")(t["primary-subscriber-id"]);
		i && (n["primary-subscriber-id"] = i);
		let a = e.required("Relationship to Subscriber")(t["primary-relationship-to-subscriber"]);
		a && (n["primary-relationship-to-subscriber"] = a);
		let s = o(t, "primary");
		if (Object.assign(n, s), t["has-secondary-insurance"]) {
			let r = e.required("Secondary Insurance Provider")(t["secondary-insurance-provider"]);
			r && (n["secondary-insurance-provider"] = r);
			let i = e.required("Secondary Subscriber ID")(t["secondary-subscriber-id"]);
			i && (n["secondary-subscriber-id"] = i);
			let a = e.required("Secondary Relationship to Subscriber")(t["secondary-relationship-to-subscriber"]);
			a && (n["secondary-relationship-to-subscriber"] = a);
			let s = o(t, "secondary");
			Object.assign(n, s);
		}
	}
	return n;
}, c = (e) => {
	let n = [];
	return e["task-type"] || n.push("Task type is required"), e.description?.trim() || n.push("Description is required"), e["task-type"] === r.code && (e["custom-task-display"]?.trim() || n.push("Custom task name is required")), e["due-date"] && t(e["due-date"]) && n.push("Due date cannot be in the past"), n;
};
export { s as validateInsuranceData, a as validatePatientContacts, i as validatePhoneNumbers, o as validateSubscriberInfo, c as validateTaskFormData };

//# sourceMappingURL=validators.mjs.map